import {MessageDisplay} from './MessageDisplay.js';

export class Chat {
	constructor(el, $) {
		this.el = el;
		this.$ = $;
		try {
			
			if (window["oneway"]){
				this.$.message.placeholder="Type a question here";
				this.$.send.innerHTML = "Ask" 
			}
			this.$.send.addEventListener(`click`, (evt)=>{
				this.sendMessage(evt);
			});
			this.$.message.addEventListener(`keyup`, (evt)=>{
				if (evt.keyCode==13) {
					this.sendMessage(evt);
				}
			});
			// this.$.message.addEventListener(`transitionend`, (evt)=>{
			// 	console.log(`transitionend`);
			// });
			// this.$.message.addEventListener(`scroll`, (evt)=>{
			// 	console.log(`scrolling`);
			// });
			document.addEventListener(`chat-message`, (evt)=>{
				this.messageReceived(evt.detail);
			});
			this.$.message.addEventListener(`focus`,(evt)=>{
				document.body.classList.add(`input-focus`);
			});
			this.$.message.addEventListener(`blur`, (evt)=>{
				document.body.classList.remove(`input-focus`);
			});
		} catch (error) {
				
		}

		this.currentlyAutoScrolling = 0;
	}
	sendMessage(evt) {
		if ('function'==typeof evt.preventDefault){
			evt.preventDefault(); evt.stopPropagation();
		}
		let text = this.$.message.value.trim();
		if (``!=text && `function`==typeof window.SendChatMessageFromInput) {
			window.SendChatMessageFromInput(this.$.message);
		}
		if (window["oneway"]){
			let msg = {
				from: "",
				text: "Your message has been sent",
				mid: ""
			};
			let m = new MessageDisplay(this.$.messages, msg);
		}

	}
	messageReceived(msg) {
		if (window["oneway"] && msg.from != "Panel" && msg.from != ""){
			return;
		}
		try {
			
			// Fetch all our scroll positions before we add our new message,
			// since these will all change when the new message is added.

			// clientHeight is the on-screen visible height of the element			
			let clientHeight = this.$.messages.clientHeight;
			// scrollHeight is the actual height of the element, were it not
			// scrolled at all
			let scrollHeight = this.$.messages.scrollHeight;
			// scrollTop is the top position of the scrolling viewport
			let scrollTop = this.$.messages.scrollTop;
			// uiDelta is a bit of leeway we give ourselves so that a 'small scroll'
			// is considered to be at the bottom anyway.
			let uiDelta = 20;

			// Add the new message
			let m = new MessageDisplay(this.$.messages, msg);

			// console.log(`scrollTop = ${scrollTop}, clientHeight = ${clientHeight}`);
			// console.log(`scrollHeight-uiDelta=${scrollHeight-uiDelta}`);
			// Check whether we were at the 'bottom', in which case we must scroll
			if (this.currentlyAutoScrolling>0 || scrollTop + clientHeight > scrollHeight - uiDelta) {
				// need to use new scrollHeight since message has been added
				//
				// problem: smooth scrolling goes wrong if a whole range of 
				// calls come in quick succession, since the scroll calculation
				// occurs before the system has finished the scroll, so by our 
				// logic the system is in a 'not-scrolled' position
				// when the next call occurs, so we scroll down a little, then
				// are not moving fast enough to keep up. Without smooth scrolling
				// this works fine. We kludge this with a counter of our current
				// auto-scrolls, so that any new message added within 300ms of an
				// auto-scroll will automatically auto-scroll as well. 300ms seems
				// sufficient for the smooth scrolling to be completed.
				this.$.messages.scrollTo({
					behavior: "smooth",
					left: 0,
					top: this.$.messages.scrollHeight-clientHeight
				});
				this.currentlyAutoScrolling++;
				setTimeout( ()=>{
					this.currentlyAutoScrolling--;
				}, 300);
			}
		} catch (error) {
				
		}
	}
}